import type { ParentType } from '@risksmart-app/domain/src/types/consts/index';
import type { GetFormConfigurationResponseRow } from '@risksmart-app/trpc/src/types';
import type { GetFormConfigurationByParentTypeQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetFormConfigurationByParentTypeDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createLazyQueryHook } from 'src/utils';

type UseLazyGetFormConfigurationByParentTypeArgs = {
  parentTypes: ParentType[];
};

export const useLazyGetFormConfigurationByParentType = createLazyQueryHook<
  UseLazyGetFormConfigurationByParentTypeArgs,
  GetFormConfigurationResponseRow[],
  GetFormConfigurationByParentTypeQuery
>({
  trpcQuery: (client, { parentTypes }) =>
    client.frontend.formConfiguration.getByParentTypes.query({
      parentTypes,
    }),
  mapTrpcDataToGraphQL: (data) => ({ form_configuration: data }),
  graphqlDocument: GetFormConfigurationByParentTypeDocument,
  graphqlVariables: ({ parentTypes }) => ({ parentTypes }),
});
